import { store } from "@/store/index.js";

const FILTER_BREAK = ":";

export default {
  dynaFilterKeyMatch(payload) {
    let filterKey = "";
    if (payload.start_date) filterKey += "start_date=" + payload.start_date;
    if (payload.end_date)   filterKey += FILTER_BREAK + "end_date=" + payload.end_date;
    if (payload.call_type)  filterKey += FILTER_BREAK + "call_type=" + payload.call_type;
    return filterKey == store.getters["presentation/scorecardDynalabelFilterKey"]
  },
  agentFilterKeyMatch(payload) {
    let filterKey = "";
    if (payload.start_date) filterKey += "start_date=" + payload.start_date;
    if (payload.end_date)   filterKey += FILTER_BREAK + "end_date=" + payload.end_date;
    if (payload.call_type)  filterKey += FILTER_BREAK + "call_type=" + payload.call_type;
    return filterKey == store.getters["presentation/scorecardAgentFilterKey"]
  }
};
